import React, { useState } from 'react'
import './App.css'
import { Scene } from './canva/Scene'
import ColorsSlider from './components/ColorSliders'
import { OptionsMenu } from './components/OptionsMenu'
import { COLORS } from './colors'
import * as THREE from 'three'
import { Canvas } from '@react-three/fiber'

const App = () => {
  const [activeOption, setActiveOption] = useState('chair')
  const [newMaterialOpt, setNewMaterialOpt] = useState({
    activeOption,
    newMTL: null,
  })

  const selectSwatch = (e) => {
    let color = COLORS[parseInt(e.target.dataset.key)]
    let newMTL

    if (color.texture) {
      let txt = new THREE.TextureLoader().load(color.texture)
      let nrm = new THREE.TextureLoader().load(color.normalMap)
      nrm.flipY = false
      nrm.flipX = true
      let rough = new THREE.TextureLoader().load(color.roughnessMap)
      rough.flipY = false

      txt.repeat.set(color.size[0], color.size[1], color.size[2], color.size[3])
      txt.flipY = false

      newMTL = new THREE.MeshStandardMaterial({
        map: txt,
        normalMap: nrm,
        roughnessMap: rough,
      })
    } else {
      newMTL = new THREE.MeshStandardMaterial({
        color: parseInt('0x' + color.color),
      })
    }

    return setNewMaterialOpt({
      activeOption,
      newMTL,
    })
  }
  return (
    <React.Fragment>
      <OptionsMenu activeOption={activeOption} setActiveOption={setActiveOption} />
      <Canvas id="rtfCanvas" tonemapping="true">
        <Scene newMaterialOpt={newMaterialOpt} />
      </Canvas>

      <div className="names_opt">
        <p className="cushion">
          <strong>&nbsp;CUSHION&nbsp;</strong>
        </p>
        <p className="wood">
          <strong>&nbsp;WOOD&nbsp;</strong>
        </p>
      </div>

      <div className="controls">
        <div className="info">
          <div className="info__message">
            <p>
              <strong>&nbsp;Grab&nbsp;</strong> to rotate. <strong>&nbsp;Scroll&nbsp;</strong> to zoom.{' '}
            </p>
          </div>
        </div>
        <ColorsSlider selectSwatch={selectSwatch} />
      </div>
      <div className="frame"></div>
    </React.Fragment>
  )
}

export default App
